<template>
    <div class="multiple-image-cta-section">
        <b-container>
            <mobile-gutter>
                <b-row class="cta-row">
                    <fade-up-animation
                        v-for="(item, i) in items"
                        :key="item.text"
                        :element="() => $refs[item.text]"
                        :y-from="(10 * i) + 50"
                    >
                        <b-col
                            sm
                            class="cta-column"
                            :ref="item.text"
                        >
                            <component
                                :is="item.to ? 'nuxt-link' : 'a'"
                                class="call-to-action"
                                :to="item.to"
                                :href="item.href || undefined"
                                :target="item.href ? '_blank' : undefined"
                                v-test:ctaLink
                            >
                                <lazy-image
                                    class="cta-image"
                                    :src="item.image.src"
                                    :alt="item.image.alt"
                                    :width="item.image.width"
                                    :height="item.image.height"
                                    v-test:ctaImage
                                />
                                <span
                                    class="cta-text"
                                    v-test:ctaText
                                >
                                    {{ item.text }}
                                </span>
                            </component>
                        </b-col>
                    </fade-up-animation>
                </b-row>
            </mobile-gutter>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'multiple-image-cta-section',

        props: {
            items: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .multiple-image-cta-section {
        padding: 40px 0;
    }

    .cta-row {
        gap: 40px;

        @include media-breakpoint-up(md) {
            gap: 0;
        }
    }

    .call-to-action {
        color: $body-color;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        height: 100%;
        gap: 10px;
        text-decoration: none;

        &:hover,
        &:focus-visible,
        &:active {
            .cta-image {
                filter: brightness(0.95);
            }

            .cta-text {
                text-decoration: underline;
                text-decoration-color: $primary;
            }
        }
    }

    .cta-image {
        max-width: 100%;
        max-height: 200px;
        width: auto;
        height: auto;
    }

    .cta-text {
        font-size: rem(24px);
        line-height: rem(32px);
        font-weight: bold;
        letter-spacing: $letter-spacing;
        text-align: center;
    }
</style>
